<template>
  <div class="KonwUs">
    <!-- 视频组 -->
    <div class="ku_page1">
      <div class="page1_video">
        <video
          src="http://vod.koalaknow.com/MTS_VideoOutput/B15CC3EDA7434F3A847B7D8B661B77AB/S00000001-200030/file.mp4"
          id="video1"
          poster="/static/app/ku_v1.png"
          class="video"
          webkit-playsinline
          playsinline
          x5-playsinline
          x-webkit-airplay="allow"
          @click="click_v(1)"
        />
        <div class="flex_start">
          <img src="/static/app/ku_shu.png" class="shu" />
          <span>100秒快速了解考拉知道</span>
        </div>
        <div class="gary">
          源自洛杉矶，服务全球的美国企业考拉知道，如何开启了在线教育新标准。
        </div>
      </div>
      <div class="page1_video">
        <video
          src="http://vod.koalaknow.com/MTS_VideoOutput/9706B45CBDD84D9BAB67732B5658B4E7/S00000001-200030/file.mp4"
          id="video2"
          poster="/static/app/ku_v2.png"
          class="video"
          webkit-playsinline
          playsinline
          x5-playsinline
          x-webkit-airplay="allow"
          @click="click_v(2)"
        />
        <div class="flex_start">
          <img src="/static/app/ku_shu.png" class="shu" />
          <span>90秒走近考拉知道师资团队</span>
        </div>
        <div class="gary">
          考拉教师专业的教育模式是怎样带领孩子快乐学习中文的。
        </div>
      </div>
    </div>
    <!-- #region课程 -->
    <div class="c_secret">
        <div class="cs_text46">让孩子爱上学中文的秘密</div>
        <div class="cs_text30">
            <div class="cs_t">考拉知道独家课程包含</div>
        </div>
        <div class="cs_list">
            <div class="csl_li" v-for="(item,index) in cs_list" :key="index">
                <img :src="'/static/app'+item.img" class="csll_img" />
                <div class="csll_num">{{item.num}}</div>
                <div class="csll_text">{{item.text}}</div>
            </div>
        </div>
        <div class="cs_text46">主体课程</div>
        <img v-for="(itemf,indexf) in index_four" :key="indexf" :src="itemf.img"  class="index_fimg"  />
        <div class="cs_text46">配套课程</div>
        <img v-for="(itemf,indexf) in index_five" :key="indexf" :src="itemf.img" class="index_fimg"  />
    </div>
    <!-- #endregion课程 -->
    <!-- 考拉知道用户反馈 -->
    <div class="page2_feedback">
      <div class="title">考拉知道用户反馈</div>
      <div class="swiper1">
        <div class="swiper-container" id="swiper1">
          <div class="swiper-wrapper p2f_swiper">
            <div
              v-for="(el, index) in arrItem"
              :key="index"
              class="swiper-slide"
            >
              <img class="img" :src="el" />
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination flex_c">
            <div
              class="dot"
              :class="a_index == index ? 'active' : ''"
              v-for="(item, index) in arrItem"
              :key="index"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!--考拉知道社会反响  -->
    <div class="page3_fan">
      <div class="title">考拉知道社会反响</div>
      <div class="p3f_swiper">
        <div class="swiper-container" id="swiper2">
          <div class="swiper-wrapper p2f_swiper">
            <div
              v-for="(el, index) in p3_item"
              :key="index"
              class="swiper-slide"
            >
              <img class="img" :src="el" />
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination flex_c">
            <div
              class="dot"
              :class="b_index == index ? 'active' : ''"
              v-for="(item, index) in p3_item"
              :key="index"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 考拉知道教育联合系统 -->
    <div class="page4_system">
      <div class="title">考拉知道教育联合系统</div>
      <div class="p4s_swiper">
        <div class="swiper-container" id="swiper3">
          <div class="swiper-wrapper p2f_swiper">
            <div
              v-for="(el, index) in p4_item"
              :key="index"
              class="swiper-slide"
            >
              <img class="img" :src="el" />
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination flex_c">
            <div
              class="dot"
              :class="c_index == index ? 'active' : ''"
              v-for="(item, index) in p4_item"
              :key="index"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from "vant";
import Swiper from "swiper";

export default {
  name: "KonwUs",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      width: "",
      arrItem: [
        "/static/app/ku_f1.png",
        "/static/app/ku_f2.png",
        "/static/app/ku_f3.png",
        "/static/app/ku_f4.png",
        "/static/app/ku_f5.png",
      ],
      a_index: 0,
      p3_item: [
        "/static/app/ku_fx1.png",
        "/static/app/ku_fx2.png",
        "/static/app/ku_fx3.png",
      ],
      b_index: 0,
      p4_item: ["/static/app/ku_foot1.png", "/static/app/ku_foot2.png"],
      c_index: 0,
      cs_list: [{
                img: '/icon-01.png',
                num: '630+',
                text: "成语知识"
            },
            {
                img: '/icon-02.png',
                num: '760+',
                text: '诗词文化'
            },
            {
                img: '/icon-03.png',
                num: '1000+',
                text: '生活场景'
            },
            {
                img: '/icon-04.png',
                num: '1800+',
                text: '跨科探索'
            },
            {
                img: '/icon5.png',
                num: '2300+',
                text: '故事场景'
            },
            {
                img: '/icon6.png',
                num: '2600+',
                text: '汉字动画'
            }
        ],
        index_four: [{
            height: 646,
            text: '汉字树阶梯识字体系',
            img: 'https://www.koalaknow.com/img/mobileimg/koalaregister/chuji.png?v=20210810'
            }, {
            height: 640,
            text: '中文自然分级体系',
            img: 'https://www.koalaknow.com/img/mobileimg/koalaregister/zhongji.png?v=20210810'
            }, {
            height: 703,
            text: '创意中文体系',
            img: 'https://www.koalaknow.com/img/mobileimg/koalaregister/gaoji.png?v=202109241'
            }], //页面第四部分的数据
            index_five: [{
            height: 453,
            img: 'https://www.koalaknow.com/img/mobileimg/koalaregister/chuangyi.png'
            }, {
            height: 405,
            img: 'https://www.koalaknow.com/img/mobileimg/koalaregister/yingdui.png'
        }], //页面第四部分的数据2
        index_five: [{
        height: 453,
        img: 'https://www.koalaknow.com/img/mobileimg/koalaregister/chuangyi.png'
        }, {
        height: 405,
        img: 'https://www.koalaknow.com/img/mobileimg/koalaregister/yingdui.png'
        }], //页面第四部分的数据2
    };
  },
  mounted() {
    document.title = "了解我们";
    this.width = document.body.clientWidth * 0.42;
    var that = this;
    new Swiper("#swiper1", {
      watchSlidesProgress: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      loopedSlides: 3,
      autoplay: true,
      on: {
        progress: function (progress) {
          // console.log(progress)
          var w_width = document.body.clientWidth / 375;
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            var slideProgress = this.slides[i].progress;
            var modify = 1;
            if (Math.abs(slideProgress) > 1) {
              modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
            }
            var translate = slideProgress * modify * 190 * w_width + "px";
            // alert(translate)
            var scale = 1 - Math.abs(slideProgress) /3;
            var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
            slide.transform(
              "translateX(" + translate + ") scale(" + scale + ")"
            );
            slide.css("zIndex", zIndex);
            slide.css("opacity", 1);
            if (Math.abs(slideProgress) > 3) {
              slide.css("opacity", 0);
            }
          }
        },
        setTransition: function (transition) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            if (slide.hasClass("swiper-slide-active")) {
              that.a_index = slide[0].dataset.swiperSlideIndex;
            }
            slide.transition(transition);
          }
        },
      },
    });
    new Swiper("#swiper2", {
      watchSlidesProgress: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      loopedSlides: 3,
      autoplay: true,
      on: {
        progress: function (progress) {},
        setTransition: function (transition) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            if (slide.hasClass("swiper-slide-active")) {
              that.b_index = slide[0].dataset.swiperSlideIndex;
            }
            slide.transition(transition);
          }
        },
      },
    });
    new Swiper("#swiper3", {
      watchSlidesProgress: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      loopedSlides: 3,
      autoplay: true,
      on: {
        progress: function (progress) {},
        setTransition: function (transition) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            if (slide.hasClass("swiper-slide-active")) {
              that.c_index = slide[0].dataset.swiperSlideIndex;
            }
            slide.transition(transition);
          }
        },
      },
    });
  },
  methods: {
    p2f_swiper(e) {
      $(".p2f_swiper .normal:eq(" + e + ")")
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
    click_v(e) {
      if ($("#video" + e).hasClass("play")) {
        $("#video" + e)
          .trigger("pause")
          .removeClass("play");
      } else {
        $("video").trigger("pause").removeClass("play");
        $("#video" + e)
          .trigger("play")
          .addClass("play");
      }
    },
  },
};
</script>
<style  scoped>
.KonwUs {
  background: #fff;
  width: 100vw;
  overflow-x: hidden;
}
.ku_page1 {
  padding: 40px 30px 0;
  box-sizing: border-box;
  background-color: #fdecee;
}
.page1_video .video {
  width: 100%;
  height: 383px;
  border-radius: 20px;
}
.page1_video .flex_start {
  line-height: 25px;
  font-size: 28px;
  color: #e6212b;
  margin: 21px 0 13px 0;
}
.page1_video .shu {
  width: 3px;
  margin: 0 14px 0 0;
}
.page1_video .gary {
  color: #666666;
  font-size: 24px;
  line-height: 30px;
  padding: 0 0 40px 18px;
  box-sizing: border-box;
}
.page2_feedback {
  margin: 80px 0 0;
  height: 596px;
  background: #e9e9e9;
  padding: 50px 40px 0;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.page2_feedback .swiper1 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.title {
  text-align: center;
  color: #333333;
  font-size: 36px;
  font-weight: bold;
}
.p2f_swiper {
  margin: 40px 0 0 0;
  height: 390px;
  display: flex;
  display: -webkit-flex;
}
.p2f_swiper img {
  width: 100%;
}
.swiper-pagination .dot {
  width: 12px;
  height: 12px;
  background: #b8b8b8;
  border-radius: 50%;
  margin: 0 10px;
}
.swiper-pagination .active {
  background: #e60012;
}
.p2f_swiper .swiper-slide {
  width: 547px;
  flex-shrink: 0;
  -webkit-flex-shrink: 0;
}
.page3_fan {
  padding: 55px 0 0;
  box-sizing: border-box;
}
.p3f_swiper .p2f_swiper .swiper-slide {
  width: 100%;
  padding: 0 50px;
  box-sizing: border-box;
}
.p3f_swiper .p2f_swiper {
  height: 500px;
}
.page4_system {
  margin: 60px 0 0 0;
  background: #fcf4e1;
  padding: 60px 0;
  box-sizing: border-box;
}
.page4_system .p2f_swiper .swiper-slide {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
}
.page4_system .p2f_swiper {
  height: 235px;
}
/* #region课程 */
.c_secret {
  background: #fff;
  position: relative;
  text-align: center;
  overflow: hidden;
}

.c_secret::before {
  position: absolute;
  content: '';
  width: 582px;
  height: 582px;
  border: 40px solid #e5e5e5;
  border-radius: 50%;
  left: 694px;
  top: 100px;
  transform: translateY(-30%);
  z-index: 0;
}

.c_secret .cs_text46 {
  font-size: 46px;
  font-weight: 500;
  color: #333;
  line-height: 64px;
  padding: 70px 0 0;
  box-sizing: border-box;
}

.c_secret .cs_text30 {
  font-size: 30px;
  color: #666;
  line-height: 39px;
  position: relative;
}

.c_secret .cs_list {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  padding: 0 60px 30px;
  box-sizing: border-box;
}

.c_secret .cs_list .csl_li {
  width: 50%;
  flex-shrink: 0;
  -webkit-flex-shrink: 0;
  text-align: center;
  margin: 45px 0 8px 0;
}

.c_secret .cs_list .csl_li .csll_img {
  width: 67px;
  height: 67px;
  display: block;
  margin: 0 auto;
}

.c_secret .cs_list .csl_li .csll_num {
  color: #e60012;
  font-size: 54px;
  margin: 28px 0 0;
  line-height: 50px;
}

.c_secret .cs_list .csl_li .csll_text {
  color: #333;
  font-size: 20px;
  line-height: 40px;
}
.index_fimg {
  width: 694px;
  height: auto;
  margin: 30px auto 20px;
    display: block;
}
/* #endregion课程 */
</style>


// WEBPACK FOOTER //
// src/components/App/Konw_Us.vue